import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateCustomFieldValue($companyId: ID!, $attributes: CustomFieldValueAttributes!) {
    createCustomFieldValue(companyId: $companyId, attributes: $attributes) {
      customFieldValue {
        id
        ...CreatedCustomFieldValues
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedCustomFieldValues on CustomFieldValue {
    id
    value
  }
`
